import { SYNC_TO_DESKTOP_APP_KEYS } from '@/types/sync/SyncKeys.ts';
import { syncToDesktopAppAction } from '@/actions/sync/SyncToDesktopAppAction.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';

export const syncStartDesktopAppSessionAction = (showTrialWarning: boolean) => {
    const sessionStore = useSessionStore();
    sessionStore.isRunBlocked = true;

    syncToDesktopAppAction(
        SYNC_TO_DESKTOP_APP_KEYS.startSession,
        JSON.stringify({
            showTrialWarning: showTrialWarning,
        }),
    );

    setTimeout(() => {
        sessionStore.isRunBlocked = false;
    }, 500);
};
